import { Nullable } from '../../types/common'
import BaseComponent from '../base-component/base-component'
import Cart from './cart'
import FreeShippingBar from './free-shipping-bar'

class CartFreeShippingBarBlock extends BaseComponent {
  cart: Nullable<Cart>

  constructor() {
    super()

    this.cart = this.closest('cart-page')
  }

  connectedCallback(): void {
    if (this.cart) {
      this.cart.subscribe('update-nodes', this.handleFinishCartUpdate)
    }
  }

  disconnectedCallback(): void {
    if (this.cart) {
      this.cart.unsubscribe('update-nodes', this.handleFinishCartUpdate)
    }
  }

  handleFinishCartUpdate = ({ node }): void => {
    this.updateByNode(node)
  }

  updateByNode(node: HTMLElement): void {
    const bar = this.querySelector<FreeShippingBar>('free-shipping-bar')
    const newBar = node.querySelector<FreeShippingBar>('free-shipping-bar')

    if (!bar || !newBar) {
      return
    }

    const difference =
      newBar.getAttribute('data-free-shipping-difference') || ''
    const differencePercent = +(
      newBar.getAttribute('data-free-shipping-difference-percent') || 0
    )

    bar.updateProgressByDifference(difference, differencePercent)
  }
}

export default CartFreeShippingBarBlock
